import styled, { keyframes } from "styled-components";
import { sizes } from "../../util";
import tile from "./pattern.png";

export const Wrapper = styled.div`
  max-width: 88rem;
  margin: 0 auto;
  @media (min-width: ${sizes.medium}) {
    // padding: 0 2rem;
  }
`;

export const GraphicWrapper = styled.div`
  background: #cbcbcb;
  & video {
    object-fit: cover;
  }
`;

export const Graphic = styled.div`
  background-image: url(${tile});
  background-size: 25rem;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  position: absolute;
  @media (min-width: ${sizes.medium}) {
    background-size: 35rem;
  }
`;

export const LogoWrapper = styled.div`
  position: relative;
  margin: ${(props) => (props.top ? "1.5rem 0" : "-4rem 0")};
`;

const rotate = keyframes`
  from {
    transform: translate(-50%, -50%) rotate(0deg);
  }

  to {
    transform: translate(-50%, -50%) rotate(360deg);
  }
`;

// export const MicaLogo = styled.div`
//   position: absolute;
//   z-index: 100;
//   right: 1.5rem;
//   svg path,
//   svg polygon,
//   svg polyline {
//     transition: 0.25s;
//     fill: ${(props) => props.theme.color};
//   }
// `;

export const MicaLogo = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80vw;
  height: 80vh;
  svg {
    height: 100%;
    width: 100%;
  }
  svg path,
  svg polygon,
  svg polyline {
    transition: 0.25s;
    fill: ${(props) => props.theme.color};
  }
  @media (min-width: ${sizes.small}) {
    width: 50vw;
    height: 50vh;
  }
`;

export const Rotate = styled.img`
  background: ${(props) => props.theme.color};
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  max-width: 80vw;
  max-height: 80vh;
  padding: 1vw;
  animation: ${rotate} 24s linear infinite;
  @media (min-width: ${sizes.medium}) {
    max-width: 50vw;
    max-height: 70vh;
  }
`;

export const Bg = styled.div`
  background: rgba(255, 255, 255, 0.65);
  padding: 2rem 0;
  @media (min-width: ${sizes.medium}) {
    padding: 2rem;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Splash/styles.js